export default __webpack_public_path__ + "static/media/npdr.a91a778f.png";